import React, { forwardRef } from 'react';
import styled from 'styled-components';
import MondayButton from 'monday-ui-react-core/dist/Button';
import PaidFeatureIcon from '../../assets/icons/paidFeature.svg';

const Icon = styled.img`
`;

const ButtonLabel = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: ${({ alignment }) => alignment};
`;

const Button = styled.button`
  display: flex;
  gap: 10px;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  &.monday-style-button--disabled {
    img {
      &.left__icon {
        opacity: 0.3;
      }
    }
  }
`;

const PaidFeatureIconWrapper = styled.img`
  margin-left: auto;
`;

const CustomButton = forwardRef(
  (
    {
      children,
      kind = 'primary',
      size = 'medium',
      icon,
      onClick,
      className = '',
      isLoading,
      height,
      width,
      disabled,
      color = false,
      isPaidFeature,
      alignment = 'left',
    },
    ref,
  ) => {
    return isLoading ? (
      <MondayButton size={size} loading={isLoading} className={className} />
    ) : disabled ? (
      <Button
        ref={ref}
        className={`custom_monday_button buttons monday-style-button monday-style-button--size-${size} monday-style-button--kind-${kind} monday-style-button--color-${
          color ? color : kind
        } has-style-size monday-style-button--disabled ${className}`}
        onClick={onClick}
      >
        {icon && (
          <Icon
            className="left__icon"
            src={icon}
            alt=""
            height={height}
            width={width}
          />
        )}
        <ButtonLabel alignment={alignment}>{children}</ButtonLabel>
        {isPaidFeature && <PaidFeatureIconWrapper src={PaidFeatureIcon} />}
      </Button>
    ) : (
      <Button
        ref={ref}
        className={`custom_monday_button buttons monday-style-button monday-style-button--size-${size} monday-style-button--kind-${kind} monday-style-button--color-${
          color ? color : kind
        } has-style-size ${className}`}
        onClick={onClick}
      >
        {icon && <Icon src={icon} alt="" height={height} width={width} />}
        <ButtonLabel>{children}</ButtonLabel>
        {isPaidFeature && <PaidFeatureIconWrapper src={PaidFeatureIcon} />}
      </Button>
    );
  },
);

export default CustomButton;
